import axios from "axios";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const faqAftesimiDual = [
    {
        question: "Çfarë është aftësimi dual?",
        answer: "Aftësimi dual është një sistem arsimor që kombinon mësimin teorik në shkollë me trajnimin praktik në kompani. Kjo i mundëson nxënësve të fitojnë njohuri profesionale dhe përvojë reale pune gjatë studimeve."
    },
    {
        question: "Cilat janë përfitimet e aftësimit dual për nxënësit?",
        answer: "Nxënësit që ndjekin aftësimin dual fitojnë aftësi praktike, rritin mundësitë për punësim pas studimeve dhe krijojnë lidhje të drejtpërdrejta me tregun e punës përmes bashkëpunimit me bizneset."
    }
];

function FaqAccordion({ whereIsShown = "student", title = "" }) {
    const [data, setData] = useState(null);

    const [expanded, setExpanded] = useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => setExpanded(newExpanded ? panel : false);

    const fetchData = () => {
        setData(faqAftesimiDual);
        axios.get(`/api/data/frequently_ask/${whereIsShown}`)
            .then((res) => {
                setData(res.data);
            })
            .catch(() => {
            });
    }

    useEffect(() => {
        fetchData()
    }, []);

    if (!data || data?.length === 0) return null;

    return (
        <div className="p-6">
            <section className="max-w-6xl mx-auto px-6">
                <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">{title}</h1>

                <div className="space-y-2 py-4">
                    {data?.map((item, index) => (
                        <Accordion
                            key={`generated_faq_accordion_${index}_${item.question}`}
                            className="border-2 border-red-500"
                            sx={{
                                borderRadius: "15px",
                                "&:first-of-type": {borderRadius: "15px"},
                                "&:last-of-type": {borderRadius: "15px"}
                            }}
                            expanded={expanded === `panel${index + 1}`}
                            onChange={handleChange(`panel${index + 1}`)}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                <p>{item.question}</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p className="text-sm text-gray-500">{item.answer}</p>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default FaqAccordion;
